// extracted by mini-css-extract-plugin
export default {"root":"GJDg0Ps0Q0SlYvFHq99D","wrap":"qZMp2HInyOAHLZXxL4Zn","modal":"unwMDIPsvf6GeKM92xWj","header":"FhC0InCmKNRFdU06etAU"};